export default {
  ERROR_GETTING_AVAILABLE_MANAGERS: "There was an error retrieving Available Managers",
  ERROR_CREATING_SALES_TEAM: "There was an error creating a Sales Team",
  ERROR_CREATING_TEAM_ASSIGNMENT: "There was an error creating a Team Assignment",
  ERROR_UPDATING_SALES_TEAM: "There was an error updating the Sales Team",
  ERROR_DELETING_SALES_TEAM: "There was an error deleting the Sales Team",
  ERROR_UNASSIGNING_USER: "There was an error unassigning the user",
  SUCCESS_CREATING_SALES_TEAM: "Sales Team created",
  SUCCESS_CREATING_TEAM_ASSIGNMENT: "Team Assignment created",
  SUCCESS_UPDATING_SALES_TEAM: "Sales Team updated",
  SUCCESS_DELETING_SALES_TEAM: "Sales Team deleted",
  SUCCESS_UNASSIGNING_USER: "User unassigned from team",
};
